import { Skeleton } from '@gonfalon/ui/skeleton';

import { AppHeader } from '#components/AppHeader';
import { Module, ModuleContent } from '#components/ui/module';

import '#stylesheets/components/AppNav.css';
import styles from './AppSkeletonBody.module.css';

export function AppSkeletonBody({ bodyOnly }: { bodyOnly?: boolean }) {
  return (
    <div role="progressbar" aria-valuetext="loading" aria-label="loading">
      {!bodyOnly && (
        <AppHeader hasDescription>
          <div className={styles.header}>
            <Skeleton width="30%" height="var(--lp-size-30)" />
            <Skeleton width="50%" height="var(--lp-size-10)" />
          </div>
        </AppHeader>
      )}
      <section>
        <Module>
          <ModuleContent>
            <Skeleton height="var(--lp-size-1200)" />
          </ModuleContent>
        </Module>
      </section>
    </div>
  );
}
